<template>
  <div>
    <b-modal
      ref="add-hw-model-modal"
      id="add-hw-model-modal"
      title="เพิ่ม Brand"
      size="sm"
      hide-footer
    >
      <b-card-text>
        <label>Brand</label>
        <b-form-input id="smallInput" size="sm" placeholder="POS" class="mb-1" v-model="brandData.hwBrandName"/>

        <label>สถานะ</label>
        <b-form-group>
          <b-form-radio-group
            v-model="brandData.hwBrandStatus"
            :options="statusOptions"            
            name="radio-inline"
          />
        </b-form-group>

        <!--- START (BTN SUBMIT) --->
        <b-row class="mt-2">
          <b-col md="12" class="d-flex justify-content-end">
            <b-button variant="primary" @click="save"
              >บันทึก</b-button
            >
          </b-col>
        </b-row>
        <!--- END (BTN SUBMIT) --->
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>

import {
  VBModal,
  BCardText,
  BRow,
  BCol,
  BFormInput,  
  BFormRadioGroup,
  BFormGroup ,
  BButton
} from "bootstrap-vue";


export default {
  props:['brandData'],
  components: {
    BCardText,
    BRow,
    BCol,
    BFormInput,    
    BFormRadioGroup,
    BFormGroup,
    BButton
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      statusSelected: 'เปิด',
      statusOptions: [
        { text: 'เปิด', value: 1 },
        { text: 'ปิด', value: 0 },        
      ],
    };
  },
  methods: {
    save() {
      if(!this.brandData.hwBrandName){
        alert("กรุณากรอกชื่อยี่ห้อ")
        return
      }

      this.$emit("emitSaveHwBrand")
      this.$refs["add-hw-model-modal"].hide();
    },
  },
};
</script>

<style>
@import "./style.css";
</style>
